// TODO:
// 1. При загрузке определяем локацию ГОТОВО
// 2. Меняем везде название лолкации на определившуюся ГОТОВО
// 3. Показываем сообщение о текущей определившейся локации Готово
// 4. Подтверждение текущей локации = запись локации и подтверждения в localStorage ГОТОВО
// 5. При повторной загрузке если было подтверждение, то сообщение не показываем ГОТОВО
// 6. При клике на Выбрать другой открываем закрываем окно с подтверждением и открываем с выбором локации ГОТОВО
// 7. При клике на локацию открываем окно с выбором локации ГОТОВО
// 8. При клике на город из списка делаем его текущем и записываем в state и localstorage ГОТОВО
// 9. При клике на город из списка закрываем окно выбора локации ГОТОВО
// 10. При подтверждении локации отправляем её на сервер ГОТОВО
// 11. При вводе данных в поисковое окно локации, скрываем списк с известными локациями и показываем список dadata ГОТОВО
// 12. При вводе данных в поисковое окно локации делакм запрос на сервер dadata ГОТОВО
// 13. После получения ответа с дадата, рендерим в список новые позиции, предварительно удалив старые ГОТОВО
// 14. Рефакторинг функций закрытия открытия модалок ГОТОВО
// 15. порабоать с удалением локаций из списка ГОТОВО
// 16. Рефакторинг добавления/удаления слушателей ГОТОВО

import {closeModal, debounce, openModal, renderElements} from "../utils/common";

const getLocation = async ({
  locationContainerSelector = `.js-location`,
  cityNameSelector = `.js-location-city`,
  confirmModalSelector = `.js-location-confirm-modal`,
  changeModalSelector = `.js-location-change-modal`,
  listSelector = `.js-location-list`,
  dadataListSelector = `.js-location-dadata-list`,
  searchInputSelectot = `.js-location-serach`,
  confirmElementClass = `js-location-confirm`,
  openChangeModalClass = `js-location-change`,
  listItemClass = `js-location-item`,
}) => {
  const locationContainers = document.querySelectorAll(locationContainerSelector);
  const cityNameElements = document.querySelectorAll(cityNameSelector);
  const confirmModalElement = document.querySelector(confirmModalSelector);
  const changeModalElement = document.querySelector(changeModalSelector);
  const listElement = changeModalElement.querySelector(listSelector);
  const dadataListElement = changeModalElement.querySelector(dadataListSelector);
  const searchInputElement = changeModalElement.querySelector(searchInputSelectot);

  const SERVER_URL = `/basket/add-region-and-city`;
  // const SERVER_URL = `/data/location.json`;

  const state = {
    coordinates: {
      lat: YMaps ? YMaps.location.latitude : 59.931,
      lon: YMaps ? YMaps.location.longitude : 30.361,
      count: 1,
    },
    modals: {
      isOpenConfirm: false,
      isOpenChange: false,
    },
    city: null,
    region: null,
  };

  // Отправляем данные на сервер
  const fetchCityToServer = async (url) => {
    const result = await fetch(`${url}?city=${state.city}&region=${state.region}`);

    if (result.status === 200) {
      return await result.json();
    }
  };

  // запрашиваем данные о текущей локации с сервера dadata
  const fetchLocationData = async (evt) => {
    const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/geolocate/address";
    const token = "b31f085e33d15c0969e770f052866a9a304a7044";
    const query = state.coordinates;

    const options = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Token " + token,
      },
      body: JSON.stringify(query),
    };

    const result = await fetch(url, options)
      .then((response) => response.json())
      .then((data) => data)
      .catch((error) => console.log("error", error));

    return await result;
  };

  // запрашиваем данные о возможной локации с сервера dadata
  const fetchLocationsFromDadata = (evt) => {
    const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
    const token = "b31f085e33d15c0969e770f052866a9a304a7044";

    const options = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Token " + token,
      },
      body: JSON.stringify({
        query: evt.target.value,
        from_bound: {value: "city"},
        to_bound: {value: "settlement"},
      }),
    };

    return fetch(url, options)
      .then((response) => response.json())
      .then((data) => renderSuggestionLocations(data))
      .catch((error) => console.log("error", error));
  };

  // Удаляем предыдущие результаты и показываем новые
  const renderSuggestionLocations = (data) => {
    if (dadataListElement.children.length) {
      Array.from(dadataListElement.children).forEach((element) => element.remove());
    }
    renderElements(dadataListElement, data.suggestions, getItemTemplateElement);
  };

  // Шаблон результата поиска
  const getItemTemplateElement = ({
    data: {
      city,
      city_with_type,
      region_with_type,
      region,
      settlement,
      settlement_with_type,
      country,
    },
  }) => {
    return `<li class="location__item js-location-item" data-location-city="${
      city !== null ? city : settlement
    }" data-location-region="${region}">
      ${city_with_type !== null ? city_with_type : settlement_with_type}, ${
      region_with_type !== city_with_type ? region_with_type : ``
    } ${country !== `Россия` ? `, ${country}` : ``}</li>`;
  };

  // записываем локацию в state
  const setStatePosition = (position) => {
    state.city = position ? position.city : `Санкт-Петербург`;
    state.region = position ? position.region : `Санкт-Петербург`;
  };

  // меняем название города
  const setCity = () => {
    cityNameElements.forEach(
      (element) =>
        (element.textContent =
          element.textContent !== state.city ? state.city : element.textContent),
    );
  };

  // Добавляем события на мобальное окно выбора локации
  const addChangeModaleEvent = () => {
    changeModalElement.addEventListener(`click`, onChageModalClick);
    searchInputElement.addEventListener(`input`, onSearchInput);
    searchInputElement.addEventListener(`input`, changeActiveList);
  };
  // Удаляем события с мобального окна выбора локации
  const removeChangeModaleEvent = () => {
    changeModalElement.removeEventListener(`click`, onChageModalClick);
    searchInputElement.removeEventListener(`input`, onSearchInput);
    searchInputElement.removeEventListener(`input`, changeActiveList);
  };

  // Закрываем окно подтверждения
  const closeConfirmModal = () => {
    closeModal(confirmModalElement);
    state.modals.isOpenConfirm = false;
    confirmModalElement.removeEventListener(`click`, onConfirmModalClick);
  };

  // записываем данные в localStorage
  const setLocalStorageData = () => {
    localStorage.location = JSON.stringify({
      region: state.region,
      city: state.city,
    });
    localStorage.locationConfirm = true;
  };

  // Отслеживаем клики на контейнере Location
  const onLocationContainerClick = (evt) => {
    if (
      evt.target.classList.contains(openChangeModalClass) ||
      evt.target.closest(`.${openChangeModalClass}`)
    ) {
      openModal(changeModalElement);
      addChangeModaleEvent();

      if (state.modals.isOpenConfirm) {
        closeConfirmModal();
      }
    }
  };

  // Отслеживаем клики в модалке выбора локации
  const onChageModalClick = (evt) => {
    if (
      evt.target.classList.contains(`js-location-change-close`) ||
      evt.target.closest(`.js-location-change-close`)
    ) {
      closeModal(evt.currentTarget);
      removeChangeModaleEvent();
    }

    if (evt.target.classList.contains(listItemClass) || evt.target.closest(`.${listItemClass}`)) {
      setStatePosition({
        city: evt.target.dataset.locationCity,
        region: evt.target.dataset.locationRegion,
      });
      setCity();
      setLocalStorageData();
      closeModal(evt.currentTarget);
      fetchCityToServer(SERVER_URL);
      removeChangeModaleEvent();
    }
  };

  // Отслеживаем клики в модалке подтверждения локации
  const onConfirmModalClick = (evt) => {
    if (evt.target.classList.contains(confirmElementClass)) {
      setLocalStorageData();

      closeConfirmModal();
      fetchCityToServer(SERVER_URL);
    }
  };

  // Дейтсвие при вводе данные в поиск
  const onSearchInput = debounce((evt) => fetchLocationsFromDadata(evt), 500);

  // Меняем активный список
  const changeActiveList = (evt) => {
    if (evt.target.value.length) {
      listElement.classList.add(`hidden`);
      dadataListElement.classList.remove(`hidden`);
    } else {
      listElement.classList.remove(`hidden`);
      dadataListElement.classList.add(`hidden`);
    }
  };

  // Иницализация скрипта
  const initLocation = async () => {
    locationContainers.forEach((locationContainer) => {
      locationContainer.addEventListener(`click`, onLocationContainerClick);
    });

    const currentPosition = await fetchLocationData();

    if (!localStorage.userConfirm && !localStorage.location) {
      setStatePosition(currentPosition.suggestions[0].data);

      setCity();

      openModal(confirmModalElement);
      state.modals.isOpenConfirm = true;
      confirmModalElement.addEventListener(`click`, onConfirmModalClick);
    } else {
      setStatePosition(JSON.parse(localStorage.location));
      setCity();
    }
  };

  initLocation();
};

export default getLocation;
